export const COLUMN_ID = 'id';
export const COLUMN_PREVIEW = 'preview';
export const COLUMN_DETAILS = 'details';

export const COLUMN_TAGS = 'tags';

export const COLUMN_CREATED_BY = 'createdById';
export const COLUMN_CREATED_DATE = 'createdDate';
export const COLUMN_UPDATED_DATE = 'updatedDate';
